import DataTable from "../components/DataTable";
import StatusBadge from "../components/StatusBadge";
import {
  formatCurrency,
  formatRequestedAt,
  formatTimeSince,
} from "../utils/formatters";

const orderStatuses = [
  "pending",
  "confirmed",
  "preparing",
  "ready",
  "completed",
  "cancelled",
  "refunded",
];

export default function OrdersTable({ orders, onOpenOrder, onStatusChange }) {
  const columns = [
    {
      key: "order",
      header: "Order",
      render: (order) => order.order_number,
    },
    {
      key: "customer",
      header: "Customer",
      render: (order) => order.customer_name,
    },
    {
      key: "location",
      header: "Location",
      render: (order) => order.location_name,
    },
    {
      key: "fulfillment",
      header: "Fulfillment",
      render: (order) => order.fulfillment_type,
    },
    {
      key: "requested",
      header: "Requested",
      render: (order) => formatRequestedAt(order.requested_date, order.requested_time),
    },
    {
      key: "total",
      header: "Total",
      render: (order) => formatCurrency(order.total),
    },
    {
      key: "payment",
      header: "Payment",
      render: (order) => order.payment_status,
    },
    {
      key: "status",
      header: "Status",
      render: (order) => {
        if (!onStatusChange) {
          return <StatusBadge status={order.status} />;
        }

        return (
          <select
            value={order.status}
            onChange={(event) => onStatusChange(order.id, event.target.value)}
          >
            {orderStatuses.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        );
      },
    },
    {
      key: "created",
      header: "Created",
      render: (order) => formatTimeSince(order.created_at),
    },
    {
      key: "actions",
      header: "",
      render: (order) => (
        <button
          className="btn btn-sm btn-secondary"
          onClick={() => onOpenOrder(order.id)}
        >
          Open
        </button>
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={orders}
      getRowKey={(order) => order.id}
      rowClassName={(order) => (order.status === "pending" ? "is-new" : "")}
    />
  );
}